<template>
  <a-modal
    v-model:visible="visible"
    width="1100px"
    title="预病历记录"
    :maskClosable="false"
    :footer="null"
  >
    <div class="body">
      <a-table
        :loading="loading"
        :dataSource="dataSource"
        :columns="columns"
        :pagination="pagination"
        rowKey="advanceMedicalRecordId"
        @change="handleSearch"
        :scroll="{ x: '100%', y: `calc(100vh - 400px )` }"
      >
        <template #action="{ record }">
          <span v-if="record.recordState === 1">
            <a-button @click="handleAction(record.parentInstanceSn)" size="small" type="link">
              查看处方
            </a-button>
          </span>
          <a-button @click="openPreview(record.advanceMedicalRecordId)" size="small" type="link">
            预病历详情
          </a-button>
        </template>
      </a-table>
      <the-detail
        v-model:visible="detail.detailVisible"
        :serialNumber="detail.serialNumber"
        :recordType="detail.recordType"
        mode="read"
      />
      <PrescriptionDetails ref="prescriptionDetails" />
    </div>
  </a-modal>
</template>

<script setup>
import { listAdvanceMedicalRecord } from '@/api/HealthRecord'
import TheDetail from '@/components/TheDetail/index.vue'
import { columns } from '@/views/PreMedicalRecord/config.js'
import { defineExpose, computed, ref, reactive } from 'vue'
import { subStringToType } from '@/utils/index'
import { useStore } from 'vuex'
import PrescriptionDetails from './PrescriptionDetails.vue'

const prescriptionDetails = ref(null)
const openPreview = id => {
  prescriptionDetails.value?.initModal(id)
}
const visible = ref(false)
const loading = ref(false)
const dataSource = ref([])
const store = useStore()
const info = computed(() => store.state.preMedicalRecord)

const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})

const detail = reactive({
  detailVisible: false,
  serialNumber: '',
  recordType: ''
})
const handleSearch = async page => {
  pagination.value.pageSize = page?.pageSize || 10
  pagination.value.current = page?.current || 1
  loading.value = true
  const params = {
    patientId: info.value.patientId,
    advanceMedicalRecordType: 6,
    pageSize: pagination.value.pageSize,
    pageNo: pagination.value.current
  }
  try {
    const result = await listAdvanceMedicalRecord(params)
    const { list, totalCount } = result
    dataSource.value = list
    pagination.value.total = totalCount
  } catch (error) {
    dataSource.value = []
  } finally {
    loading.value = false
  }
}
const handleAction = serialNumber => {
  detail.serialNumber = serialNumber
  detail.recordType = subStringToType(serialNumber)
  detail.detailVisible = true
}
const open = async () => {
  visible.value = true
  handleSearch()
}
defineExpose({
  open
})
</script>

<style lang="scss" scoped>
.body {
  // padding: 0 24px;
}
</style>
